import { SECTORS, sectorForIndustry } from '../shared/industrySectorMap';

/**
 * One-time move from the old "Filter by Industry" setting to "Filter by Sector".
 * When settings carry no `sectorsFilters` yet but do carry a non-empty
 * `industriesFilters`, derive the sectors those industries roll up to. The old
 * key is left in place; `sectorsFilters` being defined is what stops it running again.
 * Returns the same object when there is nothing to migrate.
 * @param {object} settings - a userSettings object (local or server preferences)
 * @returns {object} settings, with `sectorsFilters` added when migrated
 */
export const migrateIndustriesToSectors = (settings) => {
  if (!settings || settings.sectorsFilters !== undefined) {
    return settings;
  }
  const industries = settings.industriesFilters;
  if (!Array.isArray(industries) || industries.length === 0) {
    return settings;
  }

  const derived = new Set(industries.map(sectorForIndustry).filter(Boolean));
  return { ...settings, sectorsFilters: SECTORS.filter(sector => derived.has(sector)) };
};
